(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["idekron-quote-request"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('idekron-quote-request')) {
    customElements.define('idekron-quote-request', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const section = this.closest('.shopify-section');
        const details = this.querySelector('details');
        const quoteIds = new Set((this.dataset.quoteIds || '').split(',').filter(Boolean));
        const picker = section?.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
        if (Array.from(picker?.querySelectorAll('[data-variant-id]:checked') || []).some(option => quoteIds.has(option.dataset.variantId))) details.open = true;
        section?.addEventListener('change', (event) => {
          if (event.target.closest('variant-picker') === picker) details.open = false;
        }, { signal: this.abortController.signal });
        section?.addEventListener('submit', (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement) || !form.closest('product-form-component')) return;
          const component = form.closest('product-form-component');
          if (component.dataset.productId !== this.dataset.productId) return;
          const submittedId = form.querySelector('input[name="id"]')?.value;
          if (details.open || quoteIds.has(submittedId)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true, signal: this.abortController.signal });
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
